var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('article',{staticClass:"message"},[_c('div',{staticClass:"message-header"},[_c('p',[_vm._v("Ooops I can't seem to find that page.")])]),_c('div',{staticClass:"message-body is-flex is-justify-content-center"},[_c('img',{attrs:{"src":require("../assets/Shrug.png")}})])])
}]

export { render, staticRenderFns }